import * as React from 'react'

import { KeyPosition } from '../helpers'
import { KEY_POSITIONS } from '../constants'
import Size from '../graphics/Size'
import Sketch from '../Sketch'
const sphere = require('./images/earth.jpg')
import * as Styles from '../styles'

class Rotation {
  public keyPosition: KeyPosition
  private readonly baseSpeed = -0.1
  private currentPosition: KeyPosition = { x: 0, y: 0 }

  getNextRotation(): KeyPosition {
    if (this.keyPosition) {
      let { x, y } = this.keyPosition
      // Make (0.5, 0.5) the new origin
      x -= 0.5
      y -= 0.5

      // Fuck with the directions a little, since that works for some reason
      // *shrug*
      this.currentPosition.y += x * this.baseSpeed
      this.currentPosition.x += y * this.baseSpeed * -1
    }

    return this.currentPosition
  }
}

const getSketch = (width: number, height: number) => (p: any) => {
  let image: any
  const rotation = new Rotation()
  const minDimension = Math.min(width, height)
  const size: Size = new Size(minDimension / 3, minDimension / 2.5, 1.05)

  p.preload = () => {
    image = p.loadImage(sphere)
  }

  p.setup = () => {
    p.createCanvas(width, height, p.WEBGL)
  }

  p.draw = () => {
    p.background(0)

    p.noStroke()
    const { x, y } = rotation.getNextRotation()
    p.rotateX(x)
    p.rotateY(y)
    p.texture(image)
    p.sphere(size.getNextSize())
  }

  p.keyTyped = () => {
    const position = KEY_POSITIONS[p.key.toLowerCase()]
    if (position) {
      size.startGrowing()
      const dirX = position.x * 2 - 1
      const dirY = position.y * 2 - 1
      rotation.keyPosition = position
      p.directionalLight(255, 255, 255, -dirX, -dirY, -0.25)
    }
  }
}

const Earth = () => (
  <React.Fragment>
    <Sketch getSketch={getSketch} prompt="Use your keyboard to bump Earth to the beat" />
    <Styles.Credits>
      By original by NASA (sensor Terra/MODIS), modified by Mdf [Public domain], via Wikimedia Commons
    </Styles.Credits>
  </React.Fragment>
)

export default Earth



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Sphere/Earth.tsx